import React from 'react'
import BackArrow from '../images/tail-left.svg'
import { Link } from 'react-router-dom'
import ManualView from '../components/ManualView'
import FilesView from '../components/FilesView'
import VideoView from '../components/VideoView'
import { connect } from 'react-redux'
import ProtectedContent from './ProtectedContent'

class PDCategoryView extends React.Component {

  state = {
    activeCategory: 'Training manual'
  }



  

  selectCategory = (category) => {
    this.setState({activeCategory: category})
  }

  renderCategory = () => {

    /* Display appropriate category of resources. Filter this.props.data.categories to leave only category that has name matching this.state.activeCategory. Return name of that category and then pass category data to appropriate module - <Manual>, <Presentations> or <Handout> */

    const categoryData = this.props.data.categories.filter( category => category.name === this.state.activeCategory)

    const cleanCategoryData = categoryData[0]

    if (cleanCategoryData.name === 'Training manual') {
      return <ManualView data={this.props.data.categories[0]}/>
    } else if (cleanCategoryData.name === 'Presentations') {
      return <FilesView data={this.props.data.categories[1]}/>
    } else if (cleanCategoryData.name === 'Handouts') {
      return <FilesView data={this.props.data.categories[2]}/>
    } else if (cleanCategoryData.name === 'Videos') {
      return <VideoView data={this.props.data.categories[3]}/>
    } 

  }

  render() {

    return(

      <div>
        
        { (Object.keys(this.props.user).length) 

        ?

        <div className="container">

          <Link to={this.props.data.parentURL} style={{fontSize: 14}}>
            <div style={{display: 'flex', justifyContent: 'center'}}>
              <img alt="" style={{marginBottom: 0, marginRight: 10}} src={BackArrow} />
              <p style={{marginBottom: 0, fontSize: '14px', marginTop: 0}}>Back to all {this.props.data.parentName}</p>
            </div>
          </Link>
          <h1 style={{marginTop: '30px', textAlign: 'center'}}>{this.props.data.title}</h1>

          <div style={{textAlign: 'center'}}>
          {this.props.data.categories.map( category => 
            <button key={category.name} style={{marginRight: '15px'}} onClick={ () => this.selectCategory(category.name) } className={category.name === this.state.activeCategory ? 'active-purple-button' : 'hollow-purple-button'}>{category.name}</button>
          )}
          </div>

          {this.renderCategory()}

        </div>

        :

        <ProtectedContent />

        }

      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
      user: state.user
  };
};

export default connect(mapStateToProps)(PDCategoryView)



// WEBPACK FOOTER //
// ./src/components/PDCategoryView.js